// 各要素の「全て見る」ボタンを押した時
const disasterInformationSections = document.querySelectorAll('[data-role="disaster-information-section"]');
if(disasterInformationSections.length){
  disasterInformationSections.forEach((elm) => {
    const toggleContents = elm.querySelector('[data-role="disaster-information-contents"]');
    const toggleBtn = elm.querySelector('[data-role="contents-toggle-btn"]');
    toggleBtn.addEventListener('click', function (){
      const textSpan = this.querySelector(".txt");
      if(toggleContents.classList.contains('is-open')){
        toggleBtn.classList.remove('is-active');
        toggleContents.classList.remove('is-open');
        textSpan.textContent = '全て見る';
      } else {
        toggleBtn.classList.add('is-active');
        toggleContents.classList.add('is-open');
        textSpan.textContent = '閉じる';
      }
    });
  });
}
  